import { useEffect, useMemo, useRef, useState } from "react";
import "./Hero.css";

export default function Hero() {
  const heroRef = useRef(null);
  const [active, setActive] = useState(0);

  // Put your images in: public/hero/
  const bgImages = useMemo(
    () => [
      "/hero/img7.png",
      "/hero/img11.png",
      "/hero/img10.png",
    ],
    []
  );

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && el.classList.add("in"),
      { threshold: 0.15 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setActive((i) => (i + 1) % bgImages.length);
    }, 4500);
    return () => clearInterval(t);
  }, [bgImages.length]);

  // ✅ Change these
  const phoneDisplay = "+94 76500580";
  const phoneTel = "+94776500580";
  const whatsappNumber = "94776500580"; // no + sign

  return (
    <header className="hatcHeroWrap" ref={heroRef} id="home">
      {/* Background slider */}
      <div className="hatcHeroBgWrap" aria-hidden="true">
        {bgImages.map((src, i) => (
          <div
            key={src}
            className={`hatcHeroBg ${i === active ? "isActive" : ""}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
        <div className="hatcHeroOverlay" />
        <div className="hatcHeroGlow" />
      </div>

      <div className="hatcHeroContainer">
        <div className="hatcHeroGrid">
          {/* Left */}
          <div className="hatcHeroLeft">
            <h2 className="hatcTitle">
              New Allubomulla <span>Trade Center</span>
            </h2>

            <p className="hatcSub">
              Your one-stop place for <b>tools</b>, <b>paints</b>,{" "}
              <b>cement</b>, <b>electrical</b> & <b>plumbing</b> items.
              Quality products. Fair prices. Friendly support.
            </p>

            <div className="hatcCtas">
              <a className="hatcBtn hatcBtnMain" href="/products">
                View Products
              </a>

              <a className="hatcBtn hatcBtnGhost" href={`tel:${phoneTel}`}>
                Call Now ({phoneDisplay})
              </a>

              <a
                className="hatcBtn hatcBtnWhatsApp"
                href={`https://wa.me/${94776500580}`}
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp Message
              </a>
            </div>

            <div className="hatcMiniRow">
              <div className="hatcMiniCard">
                <b>Quick Quotation</b>
                <span>Send your list on WhatsApp</span>
              </div>
              <div className="hatcMiniCard">
                <b>Trusted Items</b>
                <span>Good brands & quality</span>
              </div>
              <div className="hatcMiniCard">
                <b>Bulk Orders</b>
                <span>For building projects</span>
              </div>
            </div>
          </div>
        </div>

        <div className="hatcScrollHint">
          <span className="hatcDot" />
          <span>Scroll to explore</span>
        </div>
      </div>
    </header>
  );
}
